const [, country] = window.location.pathname.match(/\/(\w{2})\//) || [];

// Source: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
function storageAvailable(type: 'sessionStorage' | 'localStorage'): boolean {
  try {
    const storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

const isNullish = (v: any): boolean => v === null || v === undefined;

export const setItem = <T = unknown>(key: string, value: T): void => {
  if (isNullish(value)) {
    localStorage.removeItem(key);
  } else {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  }
};

export const getItem = <T = unknown>(key: string, defaultValue: T): T => {
  if (isNullish(key)) {
    return defaultValue;
  }

  const storedValue = localStorage.getItem(key);

  if (isNullish(storedValue)) {
    return defaultValue;
  }

  try {
    return JSON.parse(storedValue ?? '');
  } catch (err) {
    console.error(err, 'Failed to parse stored value for', key);
    return defaultValue;
  }
};

export const getStorageKey = (key: string): string => `igift-${key}-${country}`;

export const setLocalStorage = <T = unknown>(key: string, newValue: T): void => {
  if (storageAvailable('localStorage')) {
    const storageKey = getStorageKey(key);
    setItem(storageKey, newValue);
  }
};

export const getLocalStorage = <T = unknown>(key: string, defaultValue: T): T => {
  if (storageAvailable('localStorage')) {
    const storageKey = getStorageKey(key);
    return getItem(storageKey, defaultValue);
  }
  return defaultValue;
};
